<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>Low Grade Reason List</nz-page-header-title>
      <nz-page-header-subtitle>Manage your low grade reasons here</nz-page-header-subtitle>
      <nz-page-header-extra>
        @if (permission.Add) {
          <button nz-button nzType="primary" (click)="showModal()">
            Add New
          </button>
        }
      </nz-page-header-extra>
    </nz-page-header>
    <nz-divider></nz-divider>

    <div style="padding: 8px; float: right;">
      <input type="text" style="width: 250px; margin-right: 8px;" nz-input placeholder="Search"
        [(ngModel)]="searchValue" (keydown)="onKeydown($event)" (ngModelChange)="ValidateText()" />
      <button nz-button nzSize="small" nzType="primary" (click)="search()"
      style="margin-right: 8px;">Search</button>
      <button nz-button nzSize="small" (click)="reset()">Reset</button>
    </div>

    <nz-table nzSize="small" [nzPageSize]="10" style="width: 100%" [nzScroll]="{ x: '900px', y: '515px' }"
      #basicTable [nzData]="LowGradeReasonList" [nzLoading]="isTableLoading" nzBordered nzShowPagination="true"
      nzShowSizeChanger [nzPageSizeOptions]="[10, 50, 100, 200, 500]" [nzShowTotal]="totalTemplate"
      nzShowQuickJumper="true" nzResponsive="true">
      <thead>
        <tr>
          <th nzWidth="60px">S.No.</th>
          <th nzWidth="120px">Reason Code</th>
          <th nzWidth="200px">Reason Name</th>
          <th nzWidth="300px">Description</th>
          <th nzWidth="160px">Added By</th>
          <th nzWidth="160px">Added Date</th>
          @if (permission.Edit || permission.Delete) {
            <th nzWidth="100px" nzRight style="text-align: center">
            Action</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (data of basicTable.data; track data) {
          <tr>
            <td>{{ data.SerialNo }}</td>
            <td>{{ data.ReasonCode }}</td>
            <td>{{ data.ReasonName }}</td>
            <td>{{ data.Description }}</td>
            <td>{{ data.AddedByName }}</td>
            <td>{{ data.AddedDate | date: 'dd-MMM-yyyy' }}</td>
            @if (permission.Edit || permission.Delete) {
              <td nzRight style="text-align: center">
                <button nz-button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu"
                  class="btn btn-sm btn-light-primary" style="line-height: 0">
                  Action <span nz-icon nzType="down"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu nzSelectable>
                    @if (permission.Edit) {
                      <li style="width: 100px;" nz-menu-item
                      (click)="OpenEditPop(data)">Edit</li>
                    }
                    @if (permission.Delete) {
                      <li style="width: 100px;" nz-menu-item
                      (click)="handleDelete(data.LowGradeReasonId)">Delete</li>
                    }
                  </ul>
                </nz-dropdown-menu>
              </td>
            }
          </tr>
        }
      </tbody>
    </nz-table>

    <nz-modal [nzWidth]="700" [nzStyle]="{ top: '20px' }" [(nzVisible)]="isVisible" [nzTitle]="modalTitle"
      [nzContent]="modalContent" [nzFooter]="null" (nzOnCancel)="handleCancel()">
      <ng-template #modalTitle>{{ PopUpTitle }}</ng-template>
      <ng-template #modalContent>
        <form nz-form [formGroup]="validateForm">
          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Reason Name</nz-form-label>
            <nz-form-control [nzSpan]="14" nzErrorTip="Enter Reason Name (3-100 characters)">
              <input nz-input formControlName="ReasonName" name="ReasonName"
                placeholder="Enter Reason Name" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Description</nz-form-label>
            <nz-form-control [nzSpan]="14" nzErrorTip="Enter Description">
              <nz-textarea-count [nzMaxCharacterCount]="500">
                <textarea nz-input formControlName="Description" name="Description"
                placeholder="Enter Description"></textarea>
              </nz-textarea-count>
            </nz-form-control>
          </nz-form-item>
          <div class="text-center">
            <button nz-button nzType="primary" [nzLoading]="isLoading" (click)="handleOk()">
              Save
            </button>
          </div>
        </form>
      </ng-template>
    </nz-modal>
  </div>
</div>
<ng-template #totalTemplate let-total>Total {{ totalItemsCount }} items</ng-template>